module.exports = "/images/BRONZE..png?8c30f65d56671e2a08e3c0396bcfb6ab";